export const trailerTypes = [
  { id: "dry_van", text: "Dry Van" },
  { id: "reefer", text: "Reefer" },
  { id: "flatbed", text: "Flatbed" },
];

export const radiusTypes = [
  { id: "50", text: "50 mi" },
  { id: "100", text: "100 mi" },
  { id: "150", text: "150 mi" },
  { id: "250", text: "250 mi" },
];

export const defaultRadiusType = radiusTypes[2];

export const UserProfileTrailerTypes = {
  dry_van: trailerTypes[0],
  reefer: trailerTypes[1],
  flatbed: trailerTypes[2],
};

export const defaultTrailerType = trailerTypes[0];

export const ThemeTypes = {
  light: { id: "light", text: "Light" },
  dark: { id: "dark", text: "Dark" },
};

export const LanguageTypes = [
  { id: "english", text: "English" },
  { id: "spanish", text: "Spanish" },
  { id: "russian", text: "Russian" },
];

export const ComparisonValues = ["LOWESTPRICE", "LOWPRICE", "MEDIUMPRICE", "HIGHPRICE", "HIGHESTPRICE"];

export const truckStatuses = [
  { id: "FREE", text: "Needs load" },
  { id: "LOADED", text: "On route" },
  { id: "OFF_DUTY", text: "Off duty" },
];

export const TruckStatus = {
  FREE: truckStatuses[0],
  LOADED: truckStatuses[1],
  OFF_DUTY: truckStatuses[2],
};

export const truckStatusText = Object.fromEntries(truckStatuses.map((s) => [s.id, s.text]));

export const trailerTypeSymbols = {
  dry_van: "V",
  reefer: "R",
  flatbed: "F",
};

export const truckBadgeStyles = {
  FREE: { color: "var(--cm-p-on-container-red)", backgroundColor: "var(--cm-p-container-red)" },
  LOADED: { color: "var(--cm-p-text-primary)", backgroundColor: "var(--cm-p-surface-container)" },
  OFF_DUTY: { color: "var(--cm-p-text-secondary)", backgroundColor: "var(--cm-p-surface-container)" },
};

export const filterBadgeStyles = {
  NO_FILTER: { color: "var(--cm-p-on-container-orange)", backgroundColor: "var(--cm-p-container-orange)" },
  HAS_FILTER: { color: "var(--cm-p-on-container-green)", backgroundColor: "var(--cm-p-accent-50)" },
};
